  document.addEventListener('DOMContentLoaded', function() {
    const radioInputs = document.querySelectorAll('input[type="radio"]');
    const effectDuration = 500; // Duration of the effect in milliseconds
    const form = document.getElementById('emailForm');
    const formInputs = form.querySelectorAll('.form-input');
    const firmaInput = document.getElementById('firma');
    const emailInput = document.getElementById('email');
    const kundennummerLabel = document.querySelector('label[for="kundennummer"]');
    const telefonLabel = document.querySelector('label[for="phone"]');
    const select = document.getElementById('country');
    const formGroup = select.closest('.form-group');

    const csrfTokenEndpoint = 'https://app.elke-plastic.com/csrf-token';

    radioInputs.forEach(input => {
      input.addEventListener('click', function() {
        this.classList.add('radio-clicked-effect');
        setTimeout(() => {
          this.classList.remove('radio-clicked-effect');
        }, effectDuration);
      });
    });

    form.addEventListener('submit', async function(event) {
      event.preventDefault();
      let formIsValid = true;
      
      const formData = new FormData(form);

      formInputs.forEach(input => {

        const inputContainer = input.parentElement;
        const errorMessage = inputContainer ? inputContainer.querySelector('.error') : null;
        const inputLabel = inputContainer ? inputContainer.querySelector(`.form-label[for="${input.id}"]`) : null;

        const isRequiredEmpty = input.required && input.value.trim() === '';

        if(isRequiredEmpty) {
          input.classList.add('is-invalid');
          formIsValid = false;
          if(errorMessage) {
            errorMessage.classList.add('display-error-msg');
          }

          if(inputLabel) {
            inputLabel.classList.add('invalid-label');
          }
        } else if(input.id === 'email' && input.value.trim() !== '') {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          const emailInvalidError = inputContainer.querySelector('.email-invalid-error');
          const emailRequiredError = inputContainer.querySelector('.email-required-error');

          if(!emailRegex.test(input.value.trim())) {
            input.classList.add('is-invalid');
            formIsValid = false;
            if (emailInvalidError) {
              emailInvalidError.classList.add('display-error-msg');
            }
            if (emailRequiredError) {
              emailRequiredError.classList.remove('display-error-msg');
            }
          } else {
            input.classList.remove('is-invalid');
            if (emailInvalidError) {
              emailInvalidError.classList.remove('display-error-msg');
            }
            if (emailRequiredError) {
              emailRequiredError.classList.remove('display-error-msg');
            }
            if (inputLabel) {
              inputLabel.classList.remove('invalid-label');
            }
          }
        } else {
          input.classList.remove('is-invalid');
          if(errorMessage) {
            errorMessage.classList.remove('display-error-msg');
          }
          if(inputLabel) {
            inputLabel.classList.remove('invalid-label');
          }
        }
      });

      if(firmaInput && kundennummerLabel) {
        if(!firmaInput.checkValidity()) {
          kundennummerLabel.classList.add('invalid-label');
        }
      }

      if(emailInput && telefonLabel) {
        if(!emailInput.checkValidity()) {
          telefonLabel.classList.add('invalid-label');
        }
      }

      if(formIsValid) {
        console.log('Form is valid and ready for submission');
        const appEndPoint = 'https://app.elke-plastic.com/send-request-mail'; // Replace with your actual endpoint

        try {
          const csrfResponse = await fetch(csrfTokenEndpoint, {
            method: 'GET',
            credentials: 'include'
          });
          if (!csrfResponse.ok) {
            throw new Error(`Failed to fetch CSRF token: ${csrfResponse.statusText}`);
          }
          const csrfData = await csrfResponse.json();
          const csrfToken = csrfData.csrf_token;
          formData.append('_token', csrfToken);

          const response = await fetch(appEndPoint, {
            method: 'POST',
            body: formData,
            credentials: 'include'
          });

          if (!response.ok) {
            const errorText = await response.text(); // Get raw response text
            try {
              const err = JSON.parse(errorText); // Try to parse as JSON
              const errorMessage = err.message || 'Server error';
              throw new Error(errorMessage);
            } catch (e) {
              throw new Error(`Server error: ${response.status} - ${errorText}`);
            }
          }
          const data = await response.json();

          if (data.success) {
            console.log('Message sent successfully!');
            // GA4 Lead-Tracking (Consent-Mode-gated via gtag) — macht B2B-Anfragen
            // (Musteranfrage / Sonderanfertigung) fuer GA4 + Google Ads Smart Bidding sichtbar.
            try {
              var _ft = (form.querySelector('[name="form_type"]') || {}).value || 'Anfrage';
              var _lead = (_ft === 'Sonderanfertigung') ? 'custom_production' : 'sample_request';
              if (typeof gtag === 'function') {
                gtag('event', 'generate_lead', {
                  lead_type: _lead,
                  form_type: _ft,
                  form_location: '7th-email-form'
                });
              }
            } catch (_e) { /* Tracking darf den Erfolg nie blockieren */ }
            form.reset();
            selectedFiles = [];
            renderFileList();
          } else {
            console.log('Error sending message: ' + (data.message || 'Unknown error'));
          }
        } catch (error) {
          console.log('Fetch error:', error);
        }
      } else {
        console.log('Form is invalid, please correct the errors');
      }
    });

    function updateSelectLabel() {
      if (select.value && select.value !== "") {
        formGroup.classList.remove("select-has-value");
      } else {
        formGroup.classList.add("select-has-value");
      }
    }

    updateSelectLabel();
    select.addEventListener('change', updateSelectLabel);
  });
  const browseButton = document.getElementById('browseButton');
  const fileInput = document.getElementById('fileInput');
  const dropZone = document.querySelector('.file-upload-dotted-frame');
  const fileUploadContent = document.querySelector('.file-upload-instructions');

  let selectedFiles = [];

  if (browseButton && fileInput && dropZone && fileUploadContent) {
    browseButton.addEventListener('click', () => {
      fileInput.click();
    });

    fileInput.addEventListener('change', (event) => {
      const files = event.target.files;
      handleFiles(files);
    });

    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
      dropZone.addEventListener(eventName, preventDefaults, false);
      document.body.addEventListener(eventName, preventDefaults, false);
    });

    ['dragenter', 'dragover'].forEach(eventName => {
      dropZone.addEventListener(eventName, highlight, false);
    });

    ['dragleave', 'drop'].forEach(eventName => {
      dropZone.addEventListener(eventName, unhighlight, false);
    });

    dropZone.addEventListener('drop', handleDrop, false);

    function preventDefaults(e) {
      e.preventDefault();
      e.stopPropagation();
    }

    function highlight() {
      dropZone.classList.add('highlight');
    }

    function unhighlight() {
      dropZone.classList.remove('highlight');
    }

    function handleDrop(e) {
      const dt = e.dataTransfer;
      const files = dt.files;
      handleFiles(files);
    }

    function handleFiles(files) {
      selectedFiles = Array.from(files);
      const dataTransfer = new DataTransfer();
      selectedFiles.forEach(file => {
        dataTransfer.items.add(file);
      });
      fileInput.files = dataTransfer.files;
      renderFileList();
    }

    function renderFileList() {
      fileUploadContent.innerHTML = '';

      if (selectedFiles.length > 0) {
        dropZone.classList.add('has-file');
        const fileListElement = document.createElement('ul');
        fileListElement.classList.add('uploaded-file-list');

        selectedFiles.forEach((file, index) => {
          const listItem = document.createElement('li');
          listItem.textContent = file.name;

          const removeButton = document.createElement('span');
          removeButton.innerHTML = '&times;';
          removeButton.classList.add('remove-file-button');
          removeButton.addEventListener('click', () => removeFile(index));

          listItem.appendChild(removeButton);
          fileListElement.appendChild(listItem);
        });
        fileUploadContent.appendChild(fileListElement);
      } else {
        dropZone.classList.remove('has-file');
        const uploadFirst = dropZone.dataset.uploadFirst;
        const uploadSecond = dropZone.dataset.uploadSecond;
        
        fileUploadContent.innerHTML = `
          <div class="centered-instructions">${uploadFirst}</div>
          <div class="centered-instructions gray">${uploadSecond}</div>
        `;
        document.getElementById('browseButton').addEventListener('click', () => {
          fileInput.click();
        });
      }
    }

    function removeFile(indexToRemove) {
      selectedFiles.splice(indexToRemove, 1);
      const dataTransfer = new DataTransfer();
      selectedFiles.forEach(file => {
        dataTransfer.items.add(file);
      });
      fileInput.files = dataTransfer.files;
      renderFileList();

      if (selectedFiles.length === 0) {
        fileInput.value = '';
      }
    }
  }
